// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// COMPONENTS
import Card from 'components/common/Card';
import ContactUsForm from 'components/forms/ContactUsForm';
import Result from 'components/common/Result';

const styles = {
  container: {
    height: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

const Jumbotron = () => (
  <div style={styles.container}>
    <h1>CONTACT US</h1>
  </div>
);

class ContactPage extends React.Component {
  state = {
    sendComplete: false,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    let isDiscount = window.localStorage.getItem('discount');
    if (isDiscount && isDiscount === 'yes') {
      this.setState({ isDiscount: true });
    }
  }

  render() {
    return (
      <div style={{ width: '100%', minHeight: '100vh', paddingBottom: 80 }}>
        <Jumbotron />
        <Card style={{ width: 450, maxWidth: '100%', margin: 'auto' }}>
          {this.state.sendComplete ? (
            <Result type="success" title="Success!" description="We will be in touch soon..." />
          ) : (
            <ContactUsForm
              initialValue={(this.props.currentUser && { user: this.props.currentUser }) || null}
              onComplete={() => this.setState({ sendComplete: true })}
            />
          )}
        </Card>
      </div>
    );
  }
}

ContactPage.propTypes = {
  currentUser: PropTypes.shape({
    emails: PropTypes.arrayOf(
      PropTypes.shape({
        address: PropTypes.string,
        verified: PropTypes.bool,
      }),
    ),
    profile: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
    organization: PropTypes.string,
  }).isRequired,
};

export default ContactPage;



// WEBPACK FOOTER //
// ./src/routes/app-contact-us/index.js